module.exports = __webpack_public_path__ + "static/desktop-frame-6e683272609c439e4c8ae6eb693fc5ad.png";